var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpQuestion24X24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24/help_question_24x24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#2B303C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "?",
    d: "M12.0076 14.3716C11.7476 14.3716 11.5408 14.2889 11.3872 14.1235C11.2454 13.9462 11.1745 13.7098 11.1745 13.4144C11.1745 13.0717 11.2159 12.7526 11.2986 12.4572C11.3813 12.1499 11.5113 11.8427 11.6886 11.5354C11.8776 11.2282 12.1258 10.915 12.4331 10.5959C12.6458 10.3478 12.8171 10.135 12.9471 9.95779C13.0889 9.76871 13.1835 9.59144 13.2307 9.426C13.2898 9.24873 13.3194 9.07147 13.3194 8.89421C13.3194 8.56332 13.1953 8.30333 12.9471 8.11425C12.7108 7.92517 12.3681 7.83063 11.919 7.83063C11.4936 7.83063 11.0977 7.88381 10.7313 7.99017C10.3768 8.09653 10.0282 8.25015 9.68549 8.45105C9.37824 8.6165 9.10052 8.68149 8.85236 8.64604C8.61601 8.59877 8.42693 8.49241 8.28512 8.32697C8.14331 8.14971 8.06058 7.9429 8.03695 7.70655C8.01331 7.4702 8.06649 7.23976 8.19648 7.01523C8.32648 6.77887 8.5451 6.57207 8.85236 6.39481C9.33687 6.11119 9.87457 5.89847 10.4654 5.75666C11.0563 5.61485 11.6058 5.54395 12.114 5.54395C12.8939 5.54395 13.5794 5.67394 14.1702 5.93392C14.7611 6.19391 15.2161 6.54843 15.5352 6.9975C15.866 7.44656 16.0315 7.97244 16.0315 8.57514C16.0315 8.94148 15.9783 9.28419 15.872 9.60326C15.7656 9.92233 15.5942 10.2414 15.3579 10.5605C15.1215 10.8677 14.7966 11.1927 14.383 11.5354C14.0166 11.8427 13.7271 12.1204 13.5144 12.3686C13.3016 12.6049 13.148 12.8353 13.0535 13.0599C12.9589 13.2726 12.8939 13.503 12.8585 13.7512C12.823 13.9285 12.7344 14.0762 12.5926 14.1944C12.4626 14.3125 12.2676 14.3716 12.0076 14.3716ZM11.9722 18.3246C11.4995 18.3246 11.1213 18.1828 10.8377 17.8992C10.5659 17.6155 10.43 17.2492 10.43 16.8001C10.43 16.3629 10.5659 16.0083 10.8377 15.7365C11.1213 15.4529 11.4995 15.3111 11.9722 15.3111C12.4449 15.3111 12.8112 15.4529 13.0712 15.7365C13.343 16.0083 13.4789 16.3629 13.4789 16.8001C13.4789 17.2492 13.343 17.6155 13.0712 17.8992C12.8112 18.1828 12.4449 18.3246 11.9722 18.3246Z",
    fill: "#2B303C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpQuestion24X24);
export default __webpack_public_path__ + "static/media/help_question_24x24.822acf184bb15d814a9f937705891efa.svg";
export { ForwardRef as ReactComponent };